import type { FC } from 'react';
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Flex } from '@chakra-ui/react';

export const FooterExtra: FC = () => {
  const data = useStaticQuery(graphql`
    query GetFooterExtraImages {
      allFile(filter: { sourceInstanceName: { eq: "images" }, relativeDirectory: { eq: "footer/extra" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(height: 50)
            }
          }
        }
      }
    }
  `);

  const items: { image: IGatsbyImageData; alt: string }[] = useMemo(() => {
    return data.allFile.edges.map(({ node }: { node: Queries.File }) => ({
      image: node.childImageSharp?.gatsbyImageData,
      alt: node.name,
    }));
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <Flex as='ul' p={0} gap={4} flexWrap='wrap' direction='row-reverse' justifyContent='center'>
      {items.map(({ image, alt }, index) => (
        <Flex key={index} as='li' listStyleType='none'>
          <GatsbyImage image={image!} alt={alt} />
        </Flex>
      ))}
    </Flex>
  );
};
